"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * Framework class for AnchorButton control
         */
        var AnchorButton = /** @class */ (function (_super) {
            __extends(AnchorButton, _super);
            function AnchorButton() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            /**
             * The keydown event handler
             * @param event The keydown event
             */
            AnchorButton.prototype.keyDown = function (evt) {
                $dyn.util.handleShortcuts(this, evt);
            };
            return AnchorButton;
        }($dyn.controls.Button));
        controls.AnchorButton = AnchorButton;
        // tslint:disable:object-literal-sort-keys
        var anchorButtonShortcuts = {
            DefaultAction: {
                Keys: { keyCode: $dyn.ui.KeyCodes.enter },
                Handler: function (evt) {
                    this.Clicked(evt);
                },
            },
        };
        AnchorButton.prototype.Shortcuts = $dyn.extendPrototype(AnchorButton.prototype.Shortcuts, anchorButtonShortcuts);
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=AnchorButton.js.map
